import { createTranslatedText } from '@dreryk/react-common';
import { CheckboxGroup, CheckboxGroupValue } from '@dreryk/react-components';

import { answerToFormValue } from '../../tab/MedicalProfileAnswer.utils';
import {
   DetailQuestionViewModel,
   FieldScope,
   MedicalProfileTabFormController,
} from '../../tab/MedicalProfileTab.types';
import { createFormFieldName } from '../../tab/MedicalProfileTab.utils';

type MultiChoiceFieldProps = Pick<MedicalProfileTabFormController, 'register'> & {
   readonly templateCode: string;
   readonly question: DetailQuestionViewModel;
   readonly disabled: boolean;
   readonly scope?: FieldScope;
};

export const MultiChoiceField = (props: MultiChoiceFieldProps): JSX.Element => {
   const selectedCodes = (answerToFormValue(props.question.answerType, props.question.existingAnswer) ??
      []) as string[];
   const availableValues: CheckboxGroupValue[] = (props.question.config?.options ?? []).map((option) => ({
      key: option.code,
      label: createTranslatedText(option.label),
      defaultValue: selectedCodes.includes(option.code),
   }));

   return (
      <CheckboxGroup
         testId={`detailQuestion-${props.question.questionId}`}
         label={createTranslatedText(props.question.content)}
         controller={props.register(createFormFieldName(props.templateCode, props.question.questionId, props.scope))}
         availableValues={availableValues}
         disabled={props.disabled}
         horizontal
      />
   );
};
